(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vip-deals"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-vipd-timer]').forEach(function (t) {
      function tick() {
        var now = new Date();
        var riyadh = new Date(now.getTime() + (now.getTimezoneOffset() + 180) * 60000);
        var left = 86400 - (riyadh.getHours() * 3600 + riyadh.getMinutes() * 60 + riyadh.getSeconds());
        var p = function (n) { return String(n).padStart(2, '0'); };
        t.querySelector('[data-h]').textContent = p(Math.floor(left / 3600));
        t.querySelector('[data-m]').textContent = p(Math.floor((left % 3600) / 60));
        t.querySelector('[data-s]').textContent = p(left % 60);
      }
      tick(); setInterval(tick, 1000);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
